const pressReleaseApp = Vue.createApp({
    data() {
        return {            
            pressReleases: pressReleases,
            pressReleasePage: 1,
            pressReleasePerPage: 2,
            pressReleasePages: [],
            totalNumberofPressReleasePages: 0
        }
    },
    methods: {

        setPressReleasePages(pressReleases) {
            this.pressReleasePages = [];
            this.totalNumberofPressReleasePages = Math.ceil(pressReleases.length / this.pressReleasePerPage);
            this.pressReleasePages = pagination(this.pressReleasePage, this.totalNumberofPressReleasePages);
        },

        paginate(items, page, perPage) {
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            return items.slice(from, to);
        },        

        resetPages() {            
            this.pressReleasePage = 1;
        },
        getImageMediaText(cmsImage) {
            return getOrchardImageMediaText(cmsImage);
        }
    },
    computed: {
        displayedPressReleases() {
            //console.log(pressReleases);         
            this.setPressReleasePages(pressReleases);
            return this.paginate(pressReleases, this.pressReleasePage, this.pressReleasePerPage);
        }
    },
    watch: {
        pressReleasePage: function (val) {
            scrollOnPagination("pressReleases");
        }
    }
});

const pressReleaseMountedApp = pressReleaseApp.mount('#pressReleases');

document.querySelectorAll('button[data-bs-toggle="tab"]').forEach((t, i) => {
    t.addEventListener('show.bs.tab', function (event) {
        var targetClass = event.target.dataset["bsTarget"];
        var panes = document.querySelectorAll(targetClass);
        var siblings = document.querySelectorAll('#product-tab-content .tab-pane.active');

        siblings.forEach(function (sibling) {
            sibling.classList.remove('show');
            sibling.classList.remove('active');
        });

        panes.forEach(function (pane) {
            pane.classList.add('show');
            pane.classList.add('active');
        });
    })
})